export default "__VITE_ASSET__BeIWXkPe__"